<template>
  <div>
    <b-form-textarea placeholder="Enter text"
                     v-model="question.GivenAnswer"
                     rows="3"
                     max-rows="6">
    </b-form-textarea>
  </div>
</template>

<script>
  export default {
    props: {
      question: {
        required: true,
        type: Object,
      },
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/surveys/types/Text.vue